<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="3" class="d-none d-md-flex">
                <TableCategory />
            </v-col>
            <v-col cols="12" md="9">
                <v-carousel hide-delimiter-background show-arrows-on-hover height="auto" class="mb-4">
                    <v-carousel-item v-for="(value, index) in product.imageset" :key="'ProductImageSet'+index" class="text-center">
                        <v-row align="center" justify="center">
                            <v-img aspect-ratio="1" :src="value" contain max-width="400" class="d-none d-md-flex"></v-img>
                            <v-img aspect-ratio="1" :src="value" class="d-block d-md-none"></v-img>
                        </v-row>
                    </v-carousel-item>
                </v-carousel>
                <div class="title mb-2 text-h4">{{product.name}}</div>
                <div class="title mb-2">Rp. {{product.price}}</div>
                <v-divider class="my-2"></v-divider>
                <div class="title" v-html="product.description"></div>
                <div v-if="product.name !== undefined" class="back text-center white--text pa-2 mt-2" @click="back">Kembali</div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import TableCategory from '@/components/TableCategory.vue';
    export default {
        props: ['id'],
        components: {
            TableCategory
        },
        data: () => ({
            product: {}
        }),
        mounted() {
            this.$store.dispatch('requestAPI', {
                name: 'product/detail',
                params: {
                    'id': this.id
                }
            }).then(async response => {
                this.product = response.data.result;
                this.product.price = await this.$store.dispatch('numberWithDots',this.product.price);
            });
        },
        methods: {
            back() {
               this.$router.go(-1);
            }
        },
    }
</script>